
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useLoader } from '@react-three/fiber'
import { MeshBasicMaterial, TextureLoader, DoubleSide } from 'three';


export default function F2Xid(props) {
    const { nodes, materials } = useGLTF(`${process.env.PUBLIC_URL}/v2/factions/f2.glb`)
    const texture = useLoader(TextureLoader, process.env.PUBLIC_URL + '/frugfrens.png');
    texture.flipY = false;
    texture.colorSpace = 'srgb';

    const baseMaterial = new MeshBasicMaterial({ map: materials['default'].map, transparent: true });

    return (
        <group {...props} dispose={null}>
            <mesh
                position={props.position}
                scale={props.scale}
                rotation={props.rotation}
                geometry={nodes.Faction_model.geometry}
                material={baseMaterial}
            >
                <mesh position={[0, 0.7, 0]} rotation={[-Math.PI / 2, 0, 0]}>
                    <circleGeometry args={[0.5, 32]} />
                    <meshBasicMaterial map={texture} transparent side={DoubleSide} toneMapped={false} />
                </mesh>
            </mesh>
        </group>
    )
}

useGLTF.preload(`${process.env.PUBLIC_URL}/v2/factions/f2.glb`)
